import axios from "axios";
import React, { useEffect, useState, useMemo, useRef } from "react";

import { CSVLink, CSVDownload } from "react-csv";
import * as yup from "yup";
import { Formik, useFormik } from "formik";
import { Link } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Backdrop,
} from "@mui/material";
import { Space } from "antd";
import { ToastContainer, toast } from "react-toastify";
// import Loader from "../../../components/Loader";
import { createTheme } from "@mui/material/styles";
// import LoginLoader from "../../../components/LoginLoader";

export default function Revenue() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState();
  const [value, setValue] = React.useState([]);
  const [file, setFile] = useState("");
  const [data, setData] = useState([]);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);
  const [download, setdownload] = useState("");
  const [hide, setHide] = useState(true);
  const [stationType, setStationType] = useState(null);
  const [client, setClient] = useState(null);
  const [disableStationType, setdisableStationType] = useState(true);
  const [yeardata, setYeardata] = useState("");
  // const [age, setAge] = useState(0);

  const formik = useFormik({
    initialValues: "initialValues",

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    onSubmit: async () => {
      try {
        if (client == "Flipkart") {
          if (stationType == "odh") {
            setOpen(true);
            const res = await axios.post(
              `http://192.168.167.66:3050/pnl/api/shipment-revenue/get/flipkart/odh`,
              {
                month: month,
                year: yeardata,
                client: client,
                startdate: 1,
                enddate: 30,
                stationType: stationType,
              }
            );
            if (res.data.responseObject.responseCode == 200) {
              setOpen(false);
              formik.handleReset();
              setHide(false);

              // await setData([result.data.blackListModel]);
              setData(res.data?.responseObject.responseObject);
              toast.success(res.data.responseObject.responseDesc, {
                theme: "colored",
              });
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusdescription);
            }
          } else {
            setOpen(true);
            const res = await axios.post(
              `http://192.168.167.66:3050/pnl/api/shipment-revenue/get/flipkart/lma`,
              {
                month: month,
                year: yeardata,
                client: client,
                startdate: 1,
                enddate: 30,
                stationType: stationType,
              }
            );
            if (res.data.responseObject.responseCode == 200) {
              setOpen(false);
              formik.handleReset();
              setHide(false);

              // await setData([result.data.blackListModel]);
              setData(res.data?.responseObject.responseObject);
              toast.success(res.data.responseObject.responseDesc, {
                theme: "colored",
              });
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusdescription);
            }
          }
        } else {
          if (stationType == "dsp") {
            setOpen(true);
            const res = await axios.post(
              `http://192.168.167.66:3050/pnl/api/shipment-revenue/get/amazon/dsp`,
              {
                month: month,
                year: yeardata,
                client: client,
                startdate: 1,
                enddate: 30,
                stationType: stationType,
              }
            );
            if (res.data.responseObject.responseCode == 200) {
              setOpen(false);
              formik.handleReset();
              setHide(false);

              // await setData([result.data.blackListModel]);
              setData(res.data?.responseObject.responseObject);
              toast.success(res.data.responseObject.responseDesc, {
                theme: "colored",
              });
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusdescription);
            }
            console.log("ooo", res);
            console.log("odhdata", res.data?.responseObject.responseObject);
          } else {
            setOpen(true);
            const res = await axios.post(
              `http://192.168.167.66:3050/pnl/api/shipment-revenue/get/amazon/edsp`,
              {
                month: month,
                year: yeardata,
                client: client,
                startdate: 1,
                enddate: 30,
                stationType: stationType,
              }
            );
            // console.log("qqq", res.data?.responseObject.responseObject);
            // setData(res.data?.responseObject.responseObject);
            console.log("qqq", res.data.responseObject.responseDesc);
            console.log("odhdata", res.data?.responseObject.responseObject);
            if (res.data.responseObject.responseCode == 200) {
              setOpen(false);
              formik.handleReset();
              setHide(false);

              // await setData([result.data.blackListModel]);
              setData(res.data?.responseObject.responseObject);
              toast.success(res.data.responseObject.responseDesc, {
                theme: "colored",
              });
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusdescription);
            }
          }
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        await toast.error("Something went wrong", {
          theme: "colored",
        });
      }
    },
  });
  const handleChangee = (event) => {
    setMonth(event.target.value);
  };
  const handleClient = (event) => {
    setClient(event.target.value);
  };
  const handleStation = (event) => {
    setStationType(event.target.value);
  };
  // console.log("station", stationType);
  // console.log("client", client);

  // const handleChange = (e) => {
  //   setYear(e?.target?.value);
  // };
  // const FlipkartRevenue = async () => {
  // };

  useEffect(() => {
    if (client == undefined) {
      setdisableStationType(true);
    } else if (client === "Amazon") {
      // alert("amaxon");
      setdisableStationType(false);
    } else if (client === "Flipkart") {
      setdisableStationType(false);
    }
  }, [client]);

  function handleupload(event) {
    setFile(event.target.files[0]);
    // setHide(false);
  }

  async function revenueupload(event) {
    try {
      setOpen(true);
      const formData = new FormData();
      formData.append("filename", file);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/pnl/api/shipment-revenue/shipment-revenue-upload`,
        formData,
        {
          headers: {
            userId: 1,
            "Content-Type": "multipart/mixed;boundary=YourBoundaryOfChoiceHere",
          },
        }
      );

      console.log("res", res);

      if (res.data.statusDescription.statusCode == 200) {
        document.getElementById("filename").value = "";
        // setHide(true);
        setOpen(false);
        // sethideDownload(false);
        // sethideBulkUpload(false);
        // BulkTableget();
        // setDownloaddata(res.data.downloadUrl);
        toast.success("File uploaded successfully", {
          theme: "colored",
        });
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage);
      }
    } catch (error) {
      setOpen(false);
      toast.error("Check Your Network");
    }
  }

  // console.log("first", client);

  // const ObjtoArray = (obj) => Object.assign([], Object.values(obj));

  // const data1 = ObjtoArray(statee);

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };
  const columns = useMemo(
    () => [
      {
        Header: "Month",
        Footer: "Month",
        accessor: "month",
      },
      {
        Header: "zone",
        Footer: "zone",
        accessor: "zone", // accessor is the "key" in the data
      },
      {
        Header: "state",
        Footer: "state",
        accessor: "state",
      },
      {
        Header: "client_name",
        Footer: "client_name",
        accessor: "client_name",
      },

      {
        Header: "station_code",
        Footer: "station_code",
        accessor: "station_code",
      },

      {
        Header: "city",
        Footer: "city",
        accessor: "city",
      },

      {
        Header: "lmdshipmentcount",
        Footer: "lmdshipmentcount",
        accessor: "revenue_pjo.lmdshipmentcount",
      },
      {
        Header: "mfnshipmentcount",
        Footer: "mfnshipmentcount",
        accessor: "revenue_pjo.mfnshipmentcount",
      },
      {
        Header: "crshipmentcount",
        Footer: "crshipmentcount",
        accessor: "revenue_pjo.crshipmentcount",
      },
      {
        Header: "armorvcount",
        Footer: "armorvcount",
        accessor: "revenue_pjo.armorvcount",
      },
      {
        Header: "shipmentrevenue",
        Footer: "shipmentrevenue",
        accessor: "revenue_pjo.shipmentrevenue",
      },
      {
        Header: "icentiverevenue",
        Footer: "icentiverevenue",
        accessor: "revenue_pjo.icentiverevenue",
      },
      {
        Header: "ihsrevenue",
        Footer: "ihsrevenue",
        accessor: "revenue_pjo.ihsrevenue",
      },
      {
        Header: "totalrevenue",
        Footer: "totalrevenue",
        accessor: "revenue_pjo.totalrevenue",
      },
      // {
      //   Header: "enddate",
      //   Footer: "enddate",
      //   accessor: "enddate",
      // },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      // defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;
  useEffect(() => {
    // FlipkartRevenue();
  }, []);

  useEffect(() => {
    console.log("qq", value);
    const date = value?.$d;
    console.log(date);
    const data2 = date?.getFullYear();
    console.log("year", data2);
    setYeardata(data2);
    // const yeardata = data2?.split(" ");
    // const yearvalue = yeardata[3];
  }, [value]);

  const downloadpnl = async (e) => {
    e.preventDefault();
    const res = await fetch(
      "http://192.168.167.66:3050/pnl/api/generate/download-pnl",

      {
        // Adding method type
        method: "POST",

        // Adding body or contents to send
        body: JSON.stringify({
          month: "7",
          year: 2022,
          client: "All",
        }),

        // Adding headers to the request
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );
    const url = window.URL.createObjectURL(new Blob([res]));
    console.log({ url });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "yourfilename.csv");
    document.body.appendChild(link);
    link.click();
    //   .then(function (resp) {
    //     return resp.blob();
    //   })
    //   .then(function (blob) {
    //     setdownload(blob.type);
    //   });
  };

  return (
    <>
      <section className="col-md-9 right_panel px-0">
        <ToastContainer />
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          {/* <LoginLoader /> */}
          {/* <Loader /> */}
        </Backdrop>

        <div className="container-fluid_1">
          <section className="tabs_8 p-4">
            <ul className="nav nav-pills mb-5" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  View
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Bulk Upload
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="bx p-4">
                  <form onSubmit={downloadpnl}>
                    <div className="row">
                      <div className="col-lg-4 col-md-6 my_2">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Stack spacing={3}>
                            <DatePicker
                              views={["year"]}
                              label="Year"
                              required
                              value={value}
                              onChange={(newvalue) => {
                                console.log("ee", newvalue);
                                setValue(newvalue);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  size="small"
                                  helperText={null}
                                />
                              )}
                            />{" "}
                          </Stack>
                        </LocalizationProvider>
                      </div>

                      <div className="col-lg-4 col-md-6 my_2">
                        <FormControl required fullWidth size="small">
                          <InputLabel
                            id="demo-simple-select-autowidth-label"
                            required
                          >
                            Month
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            required
                            value={month}
                            onChange={handleChangee}
                            autowidth
                            label="Month"
                          >
                            <MenuItem required value={1}>
                              January
                            </MenuItem>
                            <MenuItem value={2}>February</MenuItem>
                            <MenuItem value={3}>March</MenuItem>
                            <MenuItem value={4}>April</MenuItem>
                            <MenuItem value={5}>May</MenuItem>
                            <MenuItem value={6}>June</MenuItem>
                            <MenuItem value={7}>July</MenuItem>
                            <MenuItem value={8}>August</MenuItem>
                            <MenuItem value={9}>September</MenuItem>
                            <MenuItem value={10}>October</MenuItem>
                            <MenuItem value={11}>November</MenuItem>
                            <MenuItem value={12}>December</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-lg-4 col-md-6 my_2">
                        <FormControl
                          sx={{ m: 0, minWidth: 255 }}
                          size="small"
                          required
                        >
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Select Client
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={client}
                            onChange={handleClient}
                            autowidth
                            label="Select Client"
                          >
                            <MenuItem value="Flipkart">All</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    {/* {arrdata?.map((dataitem) => {
                    return (
                      <>
                        <h1>{dataitem?.city}</h1>
                      </>
                    );
                  })} */}

                    <button type="submit">Download</button>
                  </form>
                  <a href={download} download>
                    Click to download
                  </a>
                  {data?.length > 0 && (
                    <div className="card-body">
                      <div className="container-fluid p-0">
                        <div className="card shadow-none border bg_blue mt-5">
                          <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                            Recently Added
                          </span>
                          <div className="p-4">
                            <div className="d-flex justify-content-between my-3">
                              <select
                                value={pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>

                              <div></div>
                              <div className="d-flex align-items-center">
                                <span
                                  className="d-block"
                                  // onSubmit={FlipkartRevenue}
                                >
                                  Search
                                </span>
                                <input
                                  className="form-control ms-2"
                                  type="text"
                                  // value={globalSearchValue || ""}
                                  // onChange={(e) => {
                                  //   onChange(e.target.value);
                                  //   setGlobalSearchValue(e.target.value);
                                  // }}
                                />
                              </div>
                            </div>

                            {/* <div>
                              {selectedFlatRows.length > 0 && (
                                <button onClick={deletUser}>
                                  Delete Users
                                </button>
                              )}
                            </div> */}
                            <div className="table-responsive">
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-center width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className="text-center"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex justify-content-between">
                              <div>
                                <span>
                                  Page:
                                  <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                  </strong>
                                </span>

                                <span>
                                  | Go to Page :{""}
                                  <input
                                    type="number"
                                    defaultValue={pageIndex + 1}
                                    onChange={(e) => {
                                      const pageNumber = e.target.value
                                        ? Number(e.target.value) - 1
                                        : 0;
                                      gotoPage(pageNumber);
                                    }}
                                    style={{ width: "50px" }}
                                  />
                                </span>
                              </div>
                              <div>
                                <button
                                  className="btn btn_secondary m-0"
                                  type="button"
                                  disabled={!canPreviousPage}
                                  onClick={() => {
                                    previousPage();
                                  }}
                                >
                                  Prev
                                </button>

                                <button
                                  className="btn btn_secondary m-0"
                                  type="button"
                                  disabled={!canNextPage}
                                  onClick={() => {
                                    nextPage();
                                  }}
                                >
                                  Next
                                </button>
                              </div>
                              <CSVLink data={data}>Download me</CSVLink>;
                              {/* <CSVLink data={data.revenue_pjo} >
  Download me pjo
</CSVLink>; */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
              >
                <div className="bx p-4">
                  <input
                    id="filename"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    // accept=".xls, .xlsx"
                    onChange={handleupload}
                    style={{ color: "#7b809a" }}
                  />
                  <button
                    type="button"
                    className="btn btn-primary w_100 text-capitalize d-block mx-auto px-5 mt-4"
                    // data-bs-toggle="modal"
                    // data-bs-target="#exampleModal"
                    onClick={revenueupload}
                  >
                    upload
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                There is some error in uploading. Please upload again.
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-success">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
